import { recordNpsTrigger } from "./recordNpsTrigger";

export const NPS_SAVE_TRIGGER_NAMESPACE = "JobsearchFeedback";
export const NPS_SAVE_TRIGGER_KEY = "NpsSaveTriggerTimestamp";
// 30-min TTL so a stale save can't fire NPS on a much later visit.
export const SAVE_TRIGGER_TTL_MS = 30 * 60 * 1000;

export const SAVE_JOB_TOAST_DURATION_MS = 3000;
export const NPS_SAVE_TRIGGER_VALUE = "save_job";

/**
 * Records a save-job NPS trigger so the Homepage can later show the survey
 * (RN-4843). Best-effort so a failed write never blocks a save.
 */
export function recordNpsSaveTrigger(): Promise<void> {
  return recordNpsTrigger(NPS_SAVE_TRIGGER_NAMESPACE, NPS_SAVE_TRIGGER_KEY);
}
